/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CandidateTestResultDto } from '../models';
// @ts-ignore
import type { CandidateTestResultVisibilityDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { SubmitTestAnswerRequestDto } from '../models';
// @ts-ignore
import type { SubmitTestAnswerResponseDto } from '../models';
// @ts-ignore
import type { TestCurrentQuestionDto } from '../models';
// @ts-ignore
import type { TestStatusInfoDto } from '../models';
/**
 * TestExecutionApi - axios parameter creator
 * @export
 */
export const TestExecutionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the candidate\'s test result based on the current resultVisibility for the term. The visibility is taken from the per-term snapshot captured when the term started, and may downgrade from RESULT_WITH_QUESTIONS to RESULT_WITH_SCORE once the configured visibility window (in minutes after the term ends) has elapsed.  RESULT_ONLY: pass/fail only. RESULT_WITH_SCORE: pass/fail + score percentage + required threshold. RESULT_WITH_QUESTIONS: pass/fail + score + questions with correctness flag. 
         * @summary Get test result for candidate
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTestResult: async (certificationId: number, stageId: number, termId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getCandidateTestResult', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getCandidateTestResult', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getCandidateTestResult', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/test/result`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lightweight endpoint that returns the current TestResultVisibility for a term, taking into account the per-term snapshot and the configured visibility window. Intended to be polled by the candidate\'s result page while visibility is still RESULT_WITH_QUESTIONS, so the UI can react when it downgrades to RESULT_WITH_SCORE. 
         * @summary Get current result visibility for candidate
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTestResultVisibility: async (certificationId: number, stageId: number, termId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getCandidateTestResultVisibility', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getCandidateTestResultVisibility', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getCandidateTestResultVisibility', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/test/result/visibility`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the first unanswered question in the test. Answers are shuffled - positions 1-4 do not correspond to original A-D labels. Returns 204 when all questions have been answered. 
         * @summary Get current (next unanswered) test question
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentTestQuestion: async (certificationId: number, stageId: number, termId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getCurrentTestQuestion', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getCurrentTestQuestion', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getCurrentTestQuestion', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/test/questions/current`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific question by its number. Only works when allowBackNavigation is true. For already-answered questions, selectedPosition will be populated. 
         * @summary Get test question by number (back navigation)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} questionNumber 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestQuestionByNumber: async (certificationId: number, stageId: number, questionNumber: number, termId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestQuestionByNumber', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestQuestionByNumber', 'stageId', stageId)
            // verify required parameter 'questionNumber' is not null or undefined
            assertParamExists('getTestQuestionByNumber', 'questionNumber', questionNumber)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getTestQuestionByNumber', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/test/questions/{questionNumber}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"questionNumber"}}`, encodeURIComponent(String(questionNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns test execution status for the authenticated employee in the given term. Returns 200 even after the test is completed or the term has ended, so the client can detect \"end of test\" state from executionStatus / termStatus fields. 
         * @summary Get test execution status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestStatus: async (certificationId: number, stageId: number, termId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getTestStatus', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getTestStatus', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('getTestStatus', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/test/status`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a new test execution for the authenticated employee in the given term. Selects random questions from configured pools per section, shuffles answer order, and creates the execution. 
         * @summary Start test execution
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTest: async (certificationId: number, stageId: number, termId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('startTest', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('startTest', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('startTest', 'termId', termId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/test/start`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submits an answer using the correlationId from the question fetch. selectedPosition is 1-4 corresponding to the shuffled answer order. If this is the last answer, the test is auto-completed and score is calculated. 
         * @summary Submit answer to a test question
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {SubmitTestAnswerRequestDto} submitTestAnswerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTestAnswer: async (certificationId: number, stageId: number, termId: number, submitTestAnswerRequestDto: SubmitTestAnswerRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('submitTestAnswer', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('submitTestAnswer', 'stageId', stageId)
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('submitTestAnswer', 'termId', termId)
            // verify required parameter 'submitTestAnswerRequestDto' is not null or undefined
            assertParamExists('submitTestAnswer', 'submitTestAnswerRequestDto', submitTestAnswerRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/test/answers`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (termId !== undefined) {
                localVarQueryParameter['termId'] = termId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitTestAnswerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestExecutionApi - functional programming interface
 * @export
 */
export const TestExecutionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestExecutionApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the candidate\'s test result based on the current resultVisibility for the term. The visibility is taken from the per-term snapshot captured when the term started, and may downgrade from RESULT_WITH_QUESTIONS to RESULT_WITH_SCORE once the configured visibility window (in minutes after the term ends) has elapsed.  RESULT_ONLY: pass/fail only. RESULT_WITH_SCORE: pass/fail + score percentage + required threshold. RESULT_WITH_QUESTIONS: pass/fail + score + questions with correctness flag. 
         * @summary Get test result for candidate
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateTestResult(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateTestResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateTestResult(certificationId, stageId, termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestExecutionApi.getCandidateTestResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lightweight endpoint that returns the current TestResultVisibility for a term, taking into account the per-term snapshot and the configured visibility window. Intended to be polled by the candidate\'s result page while visibility is still RESULT_WITH_QUESTIONS, so the UI can react when it downgrades to RESULT_WITH_SCORE. 
         * @summary Get current result visibility for candidate
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateTestResultVisibility(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateTestResultVisibilityDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateTestResultVisibility(certificationId, stageId, termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestExecutionApi.getCandidateTestResultVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the first unanswered question in the test. Answers are shuffled - positions 1-4 do not correspond to original A-D labels. Returns 204 when all questions have been answered. 
         * @summary Get current (next unanswered) test question
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentTestQuestion(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestCurrentQuestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentTestQuestion(certificationId, stageId, termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestExecutionApi.getCurrentTestQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific question by its number. Only works when allowBackNavigation is true. For already-answered questions, selectedPosition will be populated. 
         * @summary Get test question by number (back navigation)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} questionNumber 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestQuestionByNumber(certificationId: number, stageId: number, questionNumber: number, termId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestCurrentQuestionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestQuestionByNumber(certificationId, stageId, questionNumber, termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestExecutionApi.getTestQuestionByNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns test execution status for the authenticated employee in the given term. Returns 200 even after the test is completed or the term has ended, so the client can detect \"end of test\" state from executionStatus / termStatus fields. 
         * @summary Get test execution status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestStatus(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestStatus(certificationId, stageId, termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestExecutionApi.getTestStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts a new test execution for the authenticated employee in the given term. Selects random questions from configured pools per section, shuffles answer order, and creates the execution. 
         * @summary Start test execution
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startTest(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestStatusInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startTest(certificationId, stageId, termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestExecutionApi.startTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submits an answer using the correlationId from the question fetch. selectedPosition is 1-4 corresponding to the shuffled answer order. If this is the last answer, the test is auto-completed and score is calculated. 
         * @summary Submit answer to a test question
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {SubmitTestAnswerRequestDto} submitTestAnswerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitTestAnswer(certificationId: number, stageId: number, termId: number, submitTestAnswerRequestDto: SubmitTestAnswerRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmitTestAnswerResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitTestAnswer(certificationId, stageId, termId, submitTestAnswerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestExecutionApi.submitTestAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestExecutionApi - factory interface
 * @export
 */
export const TestExecutionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestExecutionApiFp(configuration)
    return {
        /**
         * Returns the candidate\'s test result based on the current resultVisibility for the term. The visibility is taken from the per-term snapshot captured when the term started, and may downgrade from RESULT_WITH_QUESTIONS to RESULT_WITH_SCORE once the configured visibility window (in minutes after the term ends) has elapsed.  RESULT_ONLY: pass/fail only. RESULT_WITH_SCORE: pass/fail + score percentage + required threshold. RESULT_WITH_QUESTIONS: pass/fail + score + questions with correctness flag. 
         * @summary Get test result for candidate
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTestResult(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<CandidateTestResultDto> {
            return localVarFp.getCandidateTestResult(certificationId, stageId, termId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lightweight endpoint that returns the current TestResultVisibility for a term, taking into account the per-term snapshot and the configured visibility window. Intended to be polled by the candidate\'s result page while visibility is still RESULT_WITH_QUESTIONS, so the UI can react when it downgrades to RESULT_WITH_SCORE. 
         * @summary Get current result visibility for candidate
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateTestResultVisibility(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<CandidateTestResultVisibilityDto> {
            return localVarFp.getCandidateTestResultVisibility(certificationId, stageId, termId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the first unanswered question in the test. Answers are shuffled - positions 1-4 do not correspond to original A-D labels. Returns 204 when all questions have been answered. 
         * @summary Get current (next unanswered) test question
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentTestQuestion(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestCurrentQuestionDto> {
            return localVarFp.getCurrentTestQuestion(certificationId, stageId, termId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific question by its number. Only works when allowBackNavigation is true. For already-answered questions, selectedPosition will be populated. 
         * @summary Get test question by number (back navigation)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} questionNumber 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestQuestionByNumber(certificationId: number, stageId: number, questionNumber: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestCurrentQuestionDto> {
            return localVarFp.getTestQuestionByNumber(certificationId, stageId, questionNumber, termId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns test execution status for the authenticated employee in the given term. Returns 200 even after the test is completed or the term has ended, so the client can detect \"end of test\" state from executionStatus / termStatus fields. 
         * @summary Get test execution status
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestStatus(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestStatusInfoDto> {
            return localVarFp.getTestStatus(certificationId, stageId, termId, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a new test execution for the authenticated employee in the given term. Selects random questions from configured pools per section, shuffles answer order, and creates the execution. 
         * @summary Start test execution
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTest(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestStatusInfoDto> {
            return localVarFp.startTest(certificationId, stageId, termId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submits an answer using the correlationId from the question fetch. selectedPosition is 1-4 corresponding to the shuffled answer order. If this is the last answer, the test is auto-completed and score is calculated. 
         * @summary Submit answer to a test question
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {number} termId 
         * @param {SubmitTestAnswerRequestDto} submitTestAnswerRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitTestAnswer(certificationId: number, stageId: number, termId: number, submitTestAnswerRequestDto: SubmitTestAnswerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SubmitTestAnswerResponseDto> {
            return localVarFp.submitTestAnswer(certificationId, stageId, termId, submitTestAnswerRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestExecutionApi - interface
 * @export
 * @interface TestExecutionApi
 */
export interface TestExecutionApiInterface {
    /**
     * Returns the candidate\'s test result based on the current resultVisibility for the term. The visibility is taken from the per-term snapshot captured when the term started, and may downgrade from RESULT_WITH_QUESTIONS to RESULT_WITH_SCORE once the configured visibility window (in minutes after the term ends) has elapsed.  RESULT_ONLY: pass/fail only. RESULT_WITH_SCORE: pass/fail + score percentage + required threshold. RESULT_WITH_QUESTIONS: pass/fail + score + questions with correctness flag. 
     * @summary Get test result for candidate
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApiInterface
     */
    getCandidateTestResult(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<CandidateTestResultDto>;

    /**
     * Lightweight endpoint that returns the current TestResultVisibility for a term, taking into account the per-term snapshot and the configured visibility window. Intended to be polled by the candidate\'s result page while visibility is still RESULT_WITH_QUESTIONS, so the UI can react when it downgrades to RESULT_WITH_SCORE. 
     * @summary Get current result visibility for candidate
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApiInterface
     */
    getCandidateTestResultVisibility(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<CandidateTestResultVisibilityDto>;

    /**
     * Returns the first unanswered question in the test. Answers are shuffled - positions 1-4 do not correspond to original A-D labels. Returns 204 when all questions have been answered. 
     * @summary Get current (next unanswered) test question
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApiInterface
     */
    getCurrentTestQuestion(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestCurrentQuestionDto>;

    /**
     * Returns a specific question by its number. Only works when allowBackNavigation is true. For already-answered questions, selectedPosition will be populated. 
     * @summary Get test question by number (back navigation)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} questionNumber 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApiInterface
     */
    getTestQuestionByNumber(certificationId: number, stageId: number, questionNumber: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestCurrentQuestionDto>;

    /**
     * Returns test execution status for the authenticated employee in the given term. Returns 200 even after the test is completed or the term has ended, so the client can detect \"end of test\" state from executionStatus / termStatus fields. 
     * @summary Get test execution status
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApiInterface
     */
    getTestStatus(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestStatusInfoDto>;

    /**
     * Starts a new test execution for the authenticated employee in the given term. Selects random questions from configured pools per section, shuffles answer order, and creates the execution. 
     * @summary Start test execution
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApiInterface
     */
    startTest(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig): AxiosPromise<TestStatusInfoDto>;

    /**
     * Submits an answer using the correlationId from the question fetch. selectedPosition is 1-4 corresponding to the shuffled answer order. If this is the last answer, the test is auto-completed and score is calculated. 
     * @summary Submit answer to a test question
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {SubmitTestAnswerRequestDto} submitTestAnswerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApiInterface
     */
    submitTestAnswer(certificationId: number, stageId: number, termId: number, submitTestAnswerRequestDto: SubmitTestAnswerRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SubmitTestAnswerResponseDto>;

}

/**
 * TestExecutionApi - object-oriented interface
 * @export
 * @class TestExecutionApi
 * @extends {BaseAPI}
 */
export class TestExecutionApi extends BaseAPI implements TestExecutionApiInterface {
    /**
     * Returns the candidate\'s test result based on the current resultVisibility for the term. The visibility is taken from the per-term snapshot captured when the term started, and may downgrade from RESULT_WITH_QUESTIONS to RESULT_WITH_SCORE once the configured visibility window (in minutes after the term ends) has elapsed.  RESULT_ONLY: pass/fail only. RESULT_WITH_SCORE: pass/fail + score percentage + required threshold. RESULT_WITH_QUESTIONS: pass/fail + score + questions with correctness flag. 
     * @summary Get test result for candidate
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApi
     */
    public getCandidateTestResult(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig) {
        return TestExecutionApiFp(this.configuration).getCandidateTestResult(certificationId, stageId, termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lightweight endpoint that returns the current TestResultVisibility for a term, taking into account the per-term snapshot and the configured visibility window. Intended to be polled by the candidate\'s result page while visibility is still RESULT_WITH_QUESTIONS, so the UI can react when it downgrades to RESULT_WITH_SCORE. 
     * @summary Get current result visibility for candidate
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApi
     */
    public getCandidateTestResultVisibility(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig) {
        return TestExecutionApiFp(this.configuration).getCandidateTestResultVisibility(certificationId, stageId, termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the first unanswered question in the test. Answers are shuffled - positions 1-4 do not correspond to original A-D labels. Returns 204 when all questions have been answered. 
     * @summary Get current (next unanswered) test question
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApi
     */
    public getCurrentTestQuestion(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig) {
        return TestExecutionApiFp(this.configuration).getCurrentTestQuestion(certificationId, stageId, termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific question by its number. Only works when allowBackNavigation is true. For already-answered questions, selectedPosition will be populated. 
     * @summary Get test question by number (back navigation)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} questionNumber 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApi
     */
    public getTestQuestionByNumber(certificationId: number, stageId: number, questionNumber: number, termId: number, options?: RawAxiosRequestConfig) {
        return TestExecutionApiFp(this.configuration).getTestQuestionByNumber(certificationId, stageId, questionNumber, termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns test execution status for the authenticated employee in the given term. Returns 200 even after the test is completed or the term has ended, so the client can detect \"end of test\" state from executionStatus / termStatus fields. 
     * @summary Get test execution status
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApi
     */
    public getTestStatus(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig) {
        return TestExecutionApiFp(this.configuration).getTestStatus(certificationId, stageId, termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a new test execution for the authenticated employee in the given term. Selects random questions from configured pools per section, shuffles answer order, and creates the execution. 
     * @summary Start test execution
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApi
     */
    public startTest(certificationId: number, stageId: number, termId: number, options?: RawAxiosRequestConfig) {
        return TestExecutionApiFp(this.configuration).startTest(certificationId, stageId, termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submits an answer using the correlationId from the question fetch. selectedPosition is 1-4 corresponding to the shuffled answer order. If this is the last answer, the test is auto-completed and score is calculated. 
     * @summary Submit answer to a test question
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {number} termId 
     * @param {SubmitTestAnswerRequestDto} submitTestAnswerRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestExecutionApi
     */
    public submitTestAnswer(certificationId: number, stageId: number, termId: number, submitTestAnswerRequestDto: SubmitTestAnswerRequestDto, options?: RawAxiosRequestConfig) {
        return TestExecutionApiFp(this.configuration).submitTestAnswer(certificationId, stageId, termId, submitTestAnswerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

